import {
  CenterHostFamilyCost,
  CenterHostFamilyCostInput
} from '../../../lib/types/models/center/center-host-family-cost'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function updateCenterHostFamilyCosts(id: number, data: CenterHostFamilyCostInput[]) {
  return restApiClient
    .url(constructApiUrl(API.centers.updateCenterHostFamilyCosts.url, { id }))
    .patch<CenterHostFamilyCost[], CenterHostFamilyCostInput[]>(data)
}
